/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Save Filter Icon component.
 */
export const MaterialSaveFilterIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9.875 6.35352L14 6.70312L10.8682 9.41699L11.8086 13.4502L8.26367 11.3096L4.71777 13.4502L5.6582 9.41699L2.52637 6.70312L6.65137 6.35352L8.26367 2.5498L9.875 6.35352ZM7.70703 6.79492L7.4375 7.43164L6.74902 7.48926L5.33203 7.61035L6.41016 8.54492L6.93262 8.99805L6.77734 9.6748L6.45605 11.0576L7.67285 10.3232L8.26367 9.96777L8.85449 10.335L10.0703 11.0693L9.74902 9.68652L9.59375 9.00977L10.1162 8.55664L11.1943 7.62109L9.77734 7.50098L9.08984 7.44336L8.81934 6.80664L8.26367 5.49316L7.70703 6.79492Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialSaveFilterIcon;
